import { Position } from 'geojson';
import { atom, selector } from 'recoil';
import { EvaluationDistance } from '../types/evaluations';

export const evaluationDistanceState = atom<EvaluationDistance | undefined>({
  key: 'app.evaluationDistance',
  default: undefined,
});

export const evaluationDistanceLngLatsState = selector<Position[]>({
  key: 'app.evaluationsDistanceLngLats',
  get: ({ get }) => {
    const evaluationDistance = get(evaluationDistanceState);
    if (!evaluationDistance) return [];
    return [
      [evaluationDistance.firstAsset.position_longitude, evaluationDistance.firstAsset.position_latitude],
      [evaluationDistance.secondAsset.position_longitude, evaluationDistance.secondAsset.position_latitude],
    ];
  },
});
